<app-header extraClass="nav-down text-gray-innerMenu" displayNavigation="true"></app-header>
<!--HIGHLIGHT ACCORDIONS-->
<section class="faq-wrp mt-130  mb-6">
  <div class="container">
    <div class="heading">
      <h4>Frequently Asked Questions</h4>
    </div>
    <div class="highlight-accordions-wrp-inner faq-wrp-inner gray-accordion">
      <ul uk-accordion>
        <li>
          <a class="acc-title active" href="javascript:;" (click)="toggleAccordion($event.target)">How can I purchase an experience?</a>
          <div class="acc-content">
            <br>
            <p>Purchasing an experience on things 2do is a seamless and hassle free experience. Here's what you've got
              to do. </p>
            <ul>
              <li>Click on the Enquiry Now/ Book Now option for your chosen experience.</li>
              <li>Fill in the required details (Name, Number & Email ID)</li>
              <li>You will get a call within 3 working hour(10am-6pm)</li>
              <li>The availability of the experience to suit your preferred time, date and other requisites will be
                shared by our team.
              </li>
              <li>Post the confirmation you will receive a payment link on your registered email-id</li>
              <li>Once the payment is processed you can avail of your experience on the selected date and time.</li>
            </ul>
          </div>
          <!--acc-content-->
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Is it mandatory to login to purchase a deal? </a>
          <div class="acc-content"> <br>
            <p>Yes, it is mandatory to login to make a purchase.</p>
          </div>
          <!--acc-content-->
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">I have lost my voucher numbers. Can you please resend?</a>
          <div class="acc-content"> <br>
            <p>Incase you have lost your voucher number or are facing any difficulty in redeeming your experience send
              an Email to <a href="mailto:support@things2.do">support@things2.do</a> or call on <a
                href="tel:1800082728">1800082728</a></p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">What is the validity of the purchase?</a>
          <div class="acc-content"> <br>
            <p>All experiences listed on Things2.do are valid for 3 Months from date of purchase.</p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">I want to cancel the deal</a>
          <div class="acc-content"> <br>
            <p>The cancellation policy is different for different experiences. Please refer to the cancellation Policy
              mentioned at the bottom of your preferred experience page. </p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Can I change the curation</a>
          <div class="acc-content"> <br>
            <p>We have curated our existing experiences with much care to give you the perfect package each time so
              changing that would be difficult. <br/>However, if you have anything specific in mind, reach out to us on
              <a href="mailto:support@Things2.do">support@Things2.do</a> and we will be happy to curate it for you. </p>
          </div>
        </li>

        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)"> Can I gift the experience to someone else?</a>
          <div class="acc-content"> <br>
            <p>Yes, in fact our experiences are pretty much designed to be the perfect gift for your friends and
              family! </p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Where are these experiences available?</a>
          <div class="acc-content"> <br>
            <p>As of now, our experiences are available only in Mumbai and Pune, but you can expect to find them in a
              bunch of other cities across India soon! </p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Can I buy multiple experiences for the same?</a>
          <div class="acc-content"> <br>
            <p>In most cases you can, but for some experiences it might not be possible because of a limited
              inventory. </p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Can I club other experiences with the current one?</a>
          <div class="acc-content"> <br>
            <p>No, but we can customize a brand new experience for you. Give us a call on 88892029-192 and let's
              chat. </p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Are the prices inclusive of GST?</a>
          <div class="acc-content"> <br>
            <p>Yes, our experiences are inclusive of all taxes & GST.</p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Will I incur extra expenses ? </a>
          <div class="acc-content"> <br>
            <p>For anything that is not listed as a part of the experience - for example additional meals, tips, damages
              or special requests will incur an additional charge. </p>
          </div>
        </li>
        <li>
          <a class="acc-title" href="javascript:;" (click)="toggleAccordion($event.target)">Why chose Things2.do?</a>
          <div class="acc-content"> <br>
            <p>Experiences on Things2.do have been curated with extreme care and precision to bring you the best
              curations at best prices and maximum luxury! </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>
<app-footer></app-footer>
